jQuery(function($){ 
$(".swatch .swatch-element").on('click',function(){
    console.log($(this).attr("data-value"));
 
    var choose_value = $(this).attr("data-value");
    $(this).siblings(".option-title").children('span').text(choose_value);
    $(".option-title").css("text-transform", "uppercase");
     $(".option-title").removeClass("active");
    //$(".swatch").hide();
    $(".button--add-to-cart").removeClass("disabledd");
  });
  
  $(window).on('load',function() {
    var loadValu = $('.not-color-swatch .checked-li').attr('value');
    $(".not-color-swatch .option-title span").text(loadValu);
    $('.not-color-swatch .checked-li').trigger('click');
    
    var loadValuColor = $('.color-swatch .checked-li').attr('value');
    $(".color-swatch .option-title span").text(loadValuColor);
    $('.color-swatch .checked-li').trigger('click');

  });
  
  //     hide color swatch If that product have ProductColor app product
  var myVar = setInterval(setProductColor, 100);
  function setProductColor() {

    // console.log($(document).find('.shopify-product-form .webyze-large-swatche').length);
    if($(document).find('.shopify-product-form .webyze-large-swatches').length > 0){
      $('.color-swatch').hide();
      clearInterval(myVar);
    }
  }

  
//   menu accordion
  $(document).on("click", ".submenu-custom-accordion .close-dropdown", function() { 
    console.log("work");
    $(this).toggleClass("active-arrow");
    $(this).parent().siblings(".submemu-custom-accordion-ul").toggleClass("active-ul");
  });

  
  
  
});